import type { BasicBooking_sailing_route_importSettings_accompaniedList } from "../../../../../../../common/graphql/fragments/gql/BasicBooking";

export const getEnvelopeIdPlaceholder: (
  importExportType: BasicBooking_sailing_route_importSettings_accompaniedList,
) => string = (
  importExportType: BasicBooking_sailing_route_importSettings_accompaniedList,
) => importExportType.label ?? "";
